import { useEffect, useState } from 'react';
import '../css/Nav design.css';
import upload from '../images/upload_image.png';
import TopBar from './TopBar';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';
import logo from '../images/logo.jpeg';
import { Oval } from "react-loader-spinner";
import { toast } from "react-toastify";
import ImagedeleteRequest from '../model/request/ImagedeleteRequest';
import imageCompression from "browser-image-compression";
import Cropper from "react-easy-crop";

import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Notification from './Notification';

function ImageUpload() {
    const rawVal = localStorage.getItem('loginVal');
    let loginVal = rawVal ? JSON.parse(rawVal) : null;
    let token = loginVal ? loginVal.token : null;

    const [images, setImages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [cropImage, setCropImage] = useState(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [imageList, setImageList] = useState([]);
    const [selectedImageId, setSelectedImageId] = useState(null);
    const [selectPath, setSelectPath] = useState();
    const navigation = useNavigate()

    const [showMenu, setShowMenu] = useState(false);
    const [showNotif, setShowNotif] = useState(false);

    const TARGET_WIDTH = 600;
    const TARGET_HEIGHT = 800;
    const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5 MB

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);

        if (!files.length) return;

        const file = files[0];

        if (file.size > MAX_IMAGE_SIZE) {
            showToastFailed(
                `${file.name} size should not exceed 5 MB.`
            );
            return;
        }

        const preview = URL.createObjectURL(file);

        setCropImage({
            file,
            preview,
        });

        // Same image again select செய்ய முடியும்
        e.target.value = "";
    };
    const createImage = (url) =>
        new Promise((resolve, reject) => {
            const image = new Image();

            image.onload = () => resolve(image);
            image.onerror = (error) => reject(error);

            image.src = url;
        });
    const getCroppedImg = async (imageSrc, pixelCrop) => {
        const image = await createImage(imageSrc);

        const canvas = document.createElement("canvas");

        // FINAL FIXED SIZE
        canvas.width = TARGET_WIDTH;
        canvas.height = TARGET_HEIGHT;

        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            image,

            // Original crop area
            pixelCrop.x,
            pixelCrop.y,
            pixelCrop.width,
            pixelCrop.height,

            // Final image area
            0,
            0,
            TARGET_WIDTH,
            TARGET_HEIGHT
        );

        return new Promise((resolve) => {
            canvas.toBlob(
                (blob) => {
                    const croppedFile = new File(
                        [blob],
                        `profile-${Date.now()}.jpg`,
                        {
                            type: "image/jpeg",
                        }
                    );

                    resolve(croppedFile);
                },
                "image/jpeg",
                0.9
            );
        });
    };

    const onCropComplete = (croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    };
    const handleCropSave = async () => {
        try {
            if (!cropImage || !croppedAreaPixels) return;

            // Crop + Fixed 600x800 size
            const croppedFile = await getCroppedImg(
                cropImage.preview,
                croppedAreaPixels
            );

            // Compress
            const compressedFile = await imageCompression(
                croppedFile,
                {
                    maxSizeMB: 0.5,
                    maxWidthOrHeight: 1280,
                    useWebWorker: true,
                }
            );

            // Preview add
            setImages((prev) => [
                ...prev,
                {
                    file: compressedFile,
                    preview: URL.createObjectURL(compressedFile),
                },
            ]);

            // Close crop popup
            URL.revokeObjectURL(cropImage.preview);

            setCropImage(null);
            setCrop({ x: 0, y: 0 });
            setZoom(1);

        } catch (error) {
            console.error("Crop error:", error);
            showToastFailed("Unable to crop image");
        }
    };

    const handleCropCancel = () => {
        if (cropImage?.preview) {
            URL.revokeObjectURL(cropImage.preview);
        }

        setCropImage(null);
        setCrop({ x: 0, y: 0 });
        setZoom(1);
    };





    const removeImage = (index) => {
        setImages((prev) => prev.filter((_, i) => i !== index));
    };



    useEffect(() => {
        if (loginVal?.user_Id) {
            imageListAPICall(loginVal.user_Id);
        }
    }, []);

    const handleUpload = async () => {
        setIsLoading(true);

        const formData = new FormData();


        formData.append("UserId", loginVal.user_Id);

        images.forEach((img) =>
            formData.append("Files", img.file) // <-- Adjust key to match backend
        );

        try {
            imageListAPICall(loginVal.user_Id);
            const res = await axios.post(
                ApiConfig.getUrl("User/FileUpload"),
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${token}`

                    },
                }
            );

            console.log("Upload result:", res.data);
            imageListAPICall(loginVal.user_Id);
            setIsLoading(false);
            setImages([]);
            alert("Images uploaded successfully!");
        } catch (error) {
            setIsLoading(false);
            console.error("Upload error:", error);
            alert("Upload failed!");
        }
    };
    function clicktoViewpage() {
        navigation('/Viewpage')
    }

    function clickInterestPage() {
        navigation('/Interestpage')
    }
    function clickEditPage() {
        navigation('/Editprofile')
    }
    function showToast(message) {
        toast.success(message, { autoClose: 2000 });
    }

    function showToastFailed(message) {
        toast.error(message, { autoClose: 2000 });
    }


    function imageListAPICall(User_Id) {
        setIsLoading(true);
        axios.get(

            ApiConfig.getUrl("User/getImageList"),
            {
                params: {
                    User_Id: User_Id
                },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )
            .then(response => {
                const api = ApiResponse.fromJson(response.data);

                if (api.statusCode === 200) {

                    setImageList(api.response);

                    const profileImage = api.response.find(img => img.isProfileImage);

                    if (profileImage) {
                        setSelectedImageId(profileImage.id, profileImage.profilePath);
                    }
                    console.log("profilepath 1" + profileImage.profilePath);
                    setIsLoading(false);
                }
            })
            .catch(() => {
                showToastFailed("No Report Users");
                setIsLoading(false);
            });
    }


    function imageDeleteAPICall(userId, imageId) {
        setIsLoading(true);
        //    var request = new ImagedeleteRequest();
        // request.userId =253;
        // request.imageId = 29;

        //  console.log("Response:", JSON.stringify(request));
        axios.delete(
            ApiConfig.getUrl("User/imageDelete"),
            // JSON.stringify(request),
            {
                data: {
                    userId: userId,
                    imageId: imageId
                },

                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }

        )

            .then(response => {
                const api = ApiResponse.fromJson(response.data);
                console.log("Response:", api.statusCode);
                if (api.statusCode == 200) {
                    setIsLoading(false);
                    showToast(api.message);

                    imageListAPICall(loginVal.user_Id);
                } else {
                    setIsLoading(false);
                }

            })
            .catch(error => {
                setIsLoading(false);
                showToastFailed("Deleted failed!");
            });
    }


    function imageSelectionAPICall(imageId, profilePath) {
        console.log("Save Clicked", imageId);

        axios.put(
            ApiConfig.getUrl("User/imageSelection"),
            {
                userId: loginVal.user_Id,
                imageId: imageId
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )
            .then(response => {

                const api = ApiResponse.fromJson(response.data);

                if (api.status && api.statusCode === 200) {

                    // const selectedImage = imageList.find(img => img.id === imageId);

                    // if (profilePath) {
                    localStorage.setItem("image", profilePath);
                    // }


                    console.log("Profilepath" + profilePath);
                    showToast(api.message);

                    imageListAPICall(loginVal.user_Id);
                    console.log("Profilepath" + profilePath);

                    navigation("/Editprofile", { replace: true });
                } else {
                    showToastFailed(api.errorMessage);
                }

            })
            .catch(() => {
                showToastFailed("Failed to update profile image");
            });
    }




    const disableRightClick = (e) => {
        e.preventDefault();
    };



    //console.log("Type"+profile.type)
    console.log("selectedImageId:", selectedImageId);

    return (
        <div className='fullview' onContextMenu={disableRightClick}>

            {cropImage && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: "rgba(0,0,0,0.75)",
                        zIndex: 9999,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "20px",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            maxWidth: "600px",
                            background: "#fff",
                            borderRadius: "15px",
                            padding: "20px",
                        }}
                    >
                        <h4 className="text-center mb-3">
                            Adjust Your Photo
                        </h4>

                        {/* Crop Area */}
                        <div
                            style={{
                                position: "relative",
                                width: "100%",
                                height: "500px",
                                background: "#333",
                            }}
                        >
                            <Cropper
                                image={cropImage.preview}
                                crop={crop}
                                zoom={zoom}

                                // 600:800 = 3:4
                                aspect={3 / 4}

                                onCropChange={setCrop}
                                onZoomChange={setZoom}
                                onCropComplete={onCropComplete}
                            />
                        </div>

                        {/* Zoom */}
                        <div className="mt-4">
                            <label className="form-label">
                                Zoom: {zoom.toFixed(1)}x
                            </label>

                            <input
                                type="range"
                                min={1}
                                max={3}
                                step={0.1}
                                value={zoom}
                                onChange={(e) =>
                                    setZoom(Number(e.target.value))
                                }
                                className="form-range"
                            />
                        </div>

                        {/* Buttons */}
                        <div className="d-flex justify-content-end gap-2 mt-3">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={handleCropCancel}
                            >
                                Cancel
                            </button>

                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={handleCropSave}
                            >
                                Crop & Add
                            </button>
                        </div>

                    </div>
                </div>
            )}
            <div className="top-bar">
                <div className='container '>
                    <ul className=" d-flex align-items-center mb-0 position-relative">
                        <img src={logo} alt='logo' style={{ width: '90px' }} />
                        <li className='m-3 p-1' onClick={clicktoViewpage}>
                            <i className="bi bi-house d-inline m-2"></i>
                            <span className="d-none d-sm-inline text-decoration-none text-dark">All matches</span>
                        </li>
                        <li className='m-3 p-1' onClick={clickInterestPage}><i class="bi bi-heart d-inline m-2"></i>
                            <span className="d-none d-sm-inline text-decoration-none text-dark">Interests</span>

                        </li>

                        <li className='m-3 p-1' onClick={() => setShowNotif(true)}>

                            <i className="bi bi-bell d-inline m-2"></i>
                            <span className="d-none d-sm-inline  text-decoration-none text-dark">Notification</span>
                        </li>
                        {/* <li className='m-3 p-1' style={{ cursor: 'pointer' }} onClick={() => navigation('/Upgrade')}>
                            <i className="bi bi-gem d-inline m-2 text-warning"></i>
                            <span className="d-none d-sm-inline text-decoration-none text-dark fw-bold">Upgrade</span>
                        </li> */}
                        <Notification
                            show={showNotif}
                            onClose={() => setShowNotif(false)}
                        />

                    </ul>
                </div>
            </div>
            {isLoading && (
                <div className="loader-overlay">
                    <Oval
                        height={60}
                        width={60}
                        color="#ffffff"
                        secondaryColor="#cccccc"
                        strokeWidth={4}
                        visible={true}
                    />
                </div>
            )}
            <div className="container d-flex flex-column justify-content-center align-items-center min-vh-100">

                <div
                    className="card p-4 text-center"
                    style={{
                        maxWidth: "500px",
                        width: "100%",
                        borderRadius: "15px",
                        boxShadow: "0 10px 25px rgba(255, 140, 0, 0.3)",
                    }}
                >
                    <h4
                        className="mb-3 fw-semibold"
                        style={{
                            background: "linear-gradient(90deg, #ff8c00, #ff3d00)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                        }}
                    >
                        Add your photo and get much better responses!
                    </h4>

                    {/* Upload Box */}
                    <label
                        htmlFor="fileUpload"
                        className="d-flex flex-column justify-content-center align-items-center"
                        style={{
                            border: "2px dashed #ff8c00",
                            borderRadius: "12px",
                            padding: "30px",
                            cursor: "pointer",
                            backgroundColor: "#fff7f0",
                            transition: "0.3s",
                        }}
                    >
                        {images.length === 0 ? (
                            <>
                                <img
                                    src={upload}
                                    alt="upload"
                                    style={{ width: "80px", marginBottom: "10px", opacity: 0.8 }}
                                />
                                <p className="mb-1 fw-semibold text-dark">
                                    Click and Select Images Here
                                </p>
                                <small className="text-muted">Supports multiple images</small>
                            </>
                        ) : (
                            <p className="mb-0 fw-semibold text-dark">
                                Add More Images
                            </p>
                        )}
                    </label>

                    {/* Hidden Input */}
                    <input
                        id="fileUpload"
                        type="file"
                        multiple
                        accept="image/*"
                        onChange={handleImageChange}
                        style={{ display: "none" }}
                    />

                    {/* Image Preview */}
                    <div className="d-flex flex-wrap justify-content-center gap-3 mt-4">
                        {images.map((img, index) => (
                            <div
                                key={index}
                                className="position-relative"
                                style={{ width: "120px", height: "160px" }}
                            >
                                <img
                                    src={img.preview}
                                    alt="preview"
                                    className="img-thumbnail w-100 h-100"
                                    style={{
                                        objectFit: "cover",
                                        borderRadius: "10px",
                                        boxShadow: "0 4px 10px rgba(255, 140, 0, 0.25)",
                                    }}
                                />

                                <button
                                    onClick={() => removeImage(index)}
                                    className="btn btn-danger btn-sm position-absolute top-0 end-0 translate-middle rounded-circle d-flex align-items-center justify-content-center"
                                    style={{ width: "25px", height: "25px", padding: 0 }}
                                >
                                    ×
                                </button>
                            </div>
                        ))}
                    </div>

                    {/* Upload Button */}
                    <button
                        className="btn w-100 mt-4 fw-semibold"
                        onClick={handleUpload}
                        style={{
                            backgroundColor: "#ff8c00",
                            color: "white",
                            boxShadow: "0 4px 12px rgba(255, 140, 0, 0.4)",
                            border: "none",
                        }}
                    >
                        Upload
                    </button>
                    <button
                        className="btn w-100 mt-4 fw-semibold"
                        onClick={clickEditPage}
                        style={{
                            backgroundColor: "#2b90e2",
                            color: "white",
                            boxShadow: "0 4px 12px rgba(40, 127, 185, 0.4)",
                            border: "none",
                        }}
                    >
                        Close
                    </button>
                </div>

                <div className="w-50 mt-5 p-3 d-flex flex-wrap gap-2 mt-4" style={{
                    maxHeight: "400px",
                    overflowY: "auto"
                }}>
                    {imageList.map((img, index) => (
                        <div
                            key={index}
                            className="position-relative"
                            style={{
                                width: "150px",
                                height: "200px",
                            }} >


                            <input
                                type="checkbox"
                                checked={selectedImageId === img.id}
                                onChange={() => {
                                    setSelectedImageId(img.id);
                                    setSelectPath(img.profilePath);
                                }}
                                className="position-absolute"
                                style={{
                                    top: "10px",
                                    left: "10px",
                                    width: "20px",
                                    height: "20px",
                                    zIndex: 1000,
                                    cursor: "pointer"
                                }}
                            />


                            <img
                                src={img.profilePath}
                                alt="preview"
                                className="img-thumbnail w-100 h-100"
                                style={{
                                    objectFit: "cover",
                                    objectPosition: "center",
                                    borderRadius: "10px",
                                    boxShadow: "0 4px 10px rgba(255, 140, 0, 0.25)"
                                }}
                            />

                            {/* Delete Button */}
                            <button
                                onClick={() => imageDeleteAPICall(loginVal.user_Id, img.id)}
                                className="btn btn-danger btn-sm position-absolute top-0 end-0 rounded-circle d-flex align-items-center justify-content-center"
                                style={{ width: "25px", height: "25px", padding: 0 }}
                            >
                                ×
                            </button>

                        </div>
                    ))}
                    <button
                        className="btn mt-3 h-100 text-light" style={{ background: "var(--primary-color)", fontWeight: "bold" }}
                        onClick={() => {
                            if (selectedImageId) {
                                imageSelectionAPICall(selectedImageId, selectPath);
                            } else {
                                showToastFailed("Please select a profile picture.");
                            }
                        }}
                    >
                        Save Profile Picture
                    </button>

                </div>
            </div>





        </div>
    );
}

export default ImageUpload;
